import AboutSection from "../components/AboutSection";
import AboutSectionMobile from "../components/AboutSectionMobile";
import ReservationBanner from "../components/ReservationBanner";
const AboutUs = () => {
  return (
    <>
      <div className="about-mobile">
        <AboutSectionMobile />
      </div>
      <div className="about-web">
        <AboutSection />
      </div>
      <ReservationBanner />
    </>
  );
};

export default AboutUs;
